import { render } from "./AddRepair.vue?vue&type=template&id=5c579dd0"
import script from "./AddRepair.vue?vue&type=script&lang=js"
export * from "./AddRepair.vue?vue&type=script&lang=js"
script.render = render

export default script